import React from 'react'
import s from './styles.module.scss'

interface RecipientPillProps {
  children: React.ReactNode
}

const RecipientPill: React.FC<RecipientPillProps> = ({ children }) => <span className={s.pill}>{children}</span>

export default RecipientPill
